import { graphql } from 'gatsby';

import React, { Component } from 'react';
import Layout from '../layout';
import SectionThree from './hardwareComponents/SectionThree';
import SectionOne from './hardwareComponents/SectionOne';
import DemoForm from './hardwareComponents/DemoForm';
import messages from '../i18n/en';
import SectionTwo from './hardwareComponents/SectionTwoNew';
import Carousel from './hardwareComponents/CarouselDevices';
export default class HardwarePageTemplate extends Component<any, any> {
  render() {
    return (
      <Layout
        messages={messages}
        location={this.props.location}
        ogImage={this.props.data.hardware.data.Image?.[0]?.url}
        title={this.props.data.hardware.data?.Title_Tag}
        description={this.props.data.hardware.data?.Meta_Description}
        keywords={this.props.data.hardware.data?.Meta_Keywords}
        className="first-page"
      >
        <SectionOne hardware={this.props.data.hardware} />
        <SectionTwo hardware={this.props.data.hardware} />
        <SectionThree enhanced={this.props.data.hardware.data.isEAA} />
        <DemoForm hardware={this.props.data.hardware} messages={messages} />
        <Carousel
          Type={this.props.data.hardware.data?.Type}
          BrandName={this.props.data.hardware.data?.BrandLogo?.[0]?.data?.Name}
          enhanced={this.props.data.hardware.data.isEAA}
        />
      </Layout>
    );
  }
}

export const pageQuery = graphql`
  query($id: String!) {
    hardware: airtable(id: { eq: $id }) {
      table
      id
      recordId
      id
      data {
        Battery {
          data {
            Name
          }
        }
        BrandLogo {
          data {
            Name
          }
        }
        Camera {
          data {
            Name
          }
        }
        Cellular
        Cellular_Details
        Description
        display {
          data {
            Name
            size
          }
        }
        Image {
          url
        }
        Meta_Keywords
        Meta_Description
        Model {
          data {
            Name
          }
        }
        Name
        OS {
          data {
            Name
          }
        }
        Ports
        Processor
        Sensors {
          data {
            Name
          }
        }
        Slugs
        Type
        Title_Tag
        Warranty__Years_
        Weight__In_Grams_
        Dimension__H_x_W_x_T__in_mm
        WiFi
        WiFi_Details
        bluetooth
        isEAA
        ram__GB_
        rom__GB_
        size
        Audio___Video
        Accessories
        Photo {
          url
        }
        Industries {
          data {
            Name
            Photo {
              url
            }
          }
        }
      }
    }
  }
`;
